import { palette, SearchInput } from '@dev/ee-components';
import React, { FC, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import styled, { css, keyframes } from 'styled-components';

import { debounce } from '@api/services/tools/debounce';
import { parseUrlParams } from '@api/services/tools/handleUrlParams';
import { Grid } from '@material-ui/core';
import { RefreshRounded as RefreshRoundedIcon } from '@material-ui/icons';

import { FilterContextInterface, GlobalFilterOptionsContext } from '../../..';
import { SearchFilterType } from '../../../LogsFiltersBarInterfaces';
import { LogTypesString } from '@api/store/logs/types';

const rotate = keyframes`
from {
    transform: rotate(0deg);
}
to {
    transform: rotate(360deg);
}
`;
const animation = css`
    animation: ${rotate} 2s linear 1;
`;

const RefreshIcon = styled.div<{ refresh: boolean }>`
    display: flex;
    cursor: pointer;
    svg {
        ${(props) => props.refresh && animation}
    }
`;

const SearchSection = styled(Grid)`
    svg.MuiSvgIcon-root {
        margin-right: 24px;
        fill: ${palette.gray[6]};
    }
`;

export const SearchFilter: FC<SearchFilterType> = ({ emailSearch }: SearchFilterType): JSX.Element => {
    const { t } = useTranslation();
    const location = useLocation();
    const { onClicks, updateFilters, logScreenType } = useContext<FilterContextInterface>(GlobalFilterOptionsContext);
    const query = parseUrlParams(location.search);
    const [searchValue, setSearchValue] = useState(query?.search || emailSearch);
    const [refreshAnimation, setRefreshAnimation] = useState(false);

    useEffect(() => {
        setSearchValue(query?.search || emailSearch);
    }, [location.pathname]);

    const searchLogsWhereEmailStartWith = (event?: React.ChangeEvent<HTMLInputElement>): void => {
        const emailSearch = event?.target?.value || '';
        setSearchValue(emailSearch);

        debounce(
            () => {
                const updatedFilters = {
                    search: emailSearch,
                };
                updateFilters(updatedFilters);
                onClicks?.search(emailSearch);
            },
            emailSearch ? 1000 : 100
        );
    };

    return (
        <SearchSection item xs={12} sm={4} container justifyContent="flex-end" alignItems="center" wrap="nowrap">
            <RefreshIcon
                refresh={refreshAnimation}
                onAnimationEnd={() => setRefreshAnimation(false)}
                onClick={() => {
                    setRefreshAnimation(true);
                    onClicks?.refresh();
                }}
            >
                <RefreshRoundedIcon />
            </RefreshIcon>
            <Grid item xs={11} sm={10}>
                <SearchInput
                    id="searchInput"
                    name="searchInput"
                    value={searchValue}
                    onChange={searchLogsWhereEmailStartWith}
                    onDelete={searchLogsWhereEmailStartWith}
                    placeholder={logScreenType === LogTypesString.SMS ? t('searchbyphonenumber') : t('searchbyemail')}
                    type="text"
                />
            </Grid>
        </SearchSection>
    );
};
